import compatibility from "../server/shared/script-compat";
export const {
  roleKey,
  roleIdentity,
  scriptIdentityErrors,
  labels,
  isJinxTeam,
  normalizeScriptRole,
  groupLabel,
  groupNames,
  classificationDiagnostics,
  referenceGroups,
  collectJinxes,
} = compatibility;
